import { Box, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import DynamicForm from "components/DynamicForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPaymentAssignmentForMachineThunk,
  updatePaymentAssignmentThunk,
} from "store/reducers/payments";

const UpdatePaymentAssignment = ({ open, handleClose, payment, machine }) => {
  const paymentAssignmentState = useSelector(
    (state) => state.payments.paymentAssignmentInMachine
  );
  const paymentState = useSelector(
    (state) => state.payments
  );
  const assignment = paymentAssignmentState?.[payment.id]?.[machine.id];
  const [credentialFormat, setCredentialFormat] = React.useState([]);

  useEffect(() => {
    if (assignment?.data) {
      console.log("Assignment : ", assignment);
      if(assignment?.data?.authentication){
        const auth = assignment?.data?.authentication
        const format = Object.keys(auth).map((key) => ({
          name: key,
          type: typeof auth[key],
          required: true,
          value: auth[key],
        }));
        setCredentialFormat(format);
      }
      
    }
    
  }, [assignment]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getPaymentAssignmentForMachineThunk({
        payment: payment.id,
        machine: machine.id,
      })
    );
  }, [dispatch, payment.id, machine.id]);

  const onCredentialFormatSubmit = (data) => {
    console.log("Data : ", data);
    const req = {
      "authentication": data,
    }
    dispatch(updatePaymentAssignmentThunk({ id: assignment?.data?.id,data: req}));
  };
  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Update data"
    >
      <Box padding={2}>
        <DynamicForm
          items={credentialFormat}
          buttonText="Submit"
          buttonType="outlined"
          grid={{ xs: 12, md: 12, lg: 12 }}
          loading={assignment?.status === "loading"}
          onSubmit={onCredentialFormatSubmit}
          sx={{ mt: 2 }}
        />
      </Box>
      <Typography sx={{px:2,mb:1,color:"green"}}> {paymentState.updatePaymentAssignmentSuccess ? "Updated successfully" :""} </Typography>
    </CustomDialog>
  );
};

export default UpdatePaymentAssignment;
